import React from 'react';
import { pain } from '../data/content';
export function PainPoints() {
  return <section className="bg-night-panel" data-id="element-148" data-mp="2ln2iag3shpt6">
      <div className="mx-auto max-w-content px-5 pb-14 pt-6 sm:px-6 lg:pb-24 lg:pt-16" data-id="element-149" data-mp="2lm0v5d9i1cv3">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-150" data-mp="26xehdfzist5z">
          {pain.headline}
        </h2>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-3 md:grid-cols-2" data-id="element-151" data-mp="1xxhtvhova0ci">
          {pain.points.map(point => <li key={point} className="flex gap-3 rounded-2xl border border-night-line bg-night p-4 sm:p-5" data-id="element-152" data-mp="2204kjf9sxf84">
              <span aria-hidden="true" className="mt-2.5 h-1.5 w-1.5 flex-none rounded-full bg-gold-soft" data-id="element-153" data-mp="1syeqs2sg6476" />
              <span className="font-sans text-[1.05rem] leading-relaxed text-parchment" data-id="element-154" data-mp="3ie4dg6a8c4lv">
                {point}
              </span>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-gold-soft/40 bg-gold/10 px-6 py-7 text-center" data-id="element-155" data-mp="1yzn3jiw8v6fk">
          <p className="font-display text-2xl font-semibold leading-snug text-gold-soft sm:text-3xl" data-id="element-156" data-mp="1u12dudemc55d">
            {pain.claim}
          </p>
          <p className="mt-3 font-sans text-base leading-relaxed text-parchment/80" data-id="element-157" data-mp="23rdgzxqhaab7">
            {pain.close}
          </p>
        </div>
      </div>
    </section>;
}